import React, { useState, useEffect } from 'react';

import { makeStyles } from '@mui/styles';
import Search from '../../../common/Search';
import Node from '../../../common/Node';

import CommonStyles from '../../../common/CommonStyles';
import GeneratePublicInvite from './GeneratePublicInvite';

import { Table, TableBody } from '@mui/material';

import InviteRow from './InviteRow';

const useStyles = makeStyles({
  ...CommonStyles,
  inviteContainer: {
    background: '#fff',
    padding: '20px 30px 10px 30px',
  },
});

const PublicInviteTab = ({
  publicInvites, 
  createInvite, 
  accountsTbox,
  setupAncestors,
  onEnableInvite,
  deleteInvitation,
  allSetupAccounts,
}) => {
  const [selectedRole, setSelectedRole] = useState(null);

  const classes = useStyles({});

  useEffect(() => {
  }, [publicInvites]);

  const onRemoveRoleClick = () => {
    setSelectedRole(null);
  };

  const onChooseRoleClick = (role) => {
    setSelectedRole(role);
  };

  return (
    <div>
      {setupAncestors && setupAncestors.length ?
        <div>
          <div style={{ display: 'flex' }} className={classes.inviteContainer}>
            <div style={{ alignSelf: 'center', marginLeft: '20px' }}>
              <span className={`${classes.columnHeadingGeneral} ${classes.mb10}`}>Choose role</span>
              <div className={`${classes.mt5} ${classes.mb5}`}>
                {selectedRole ? (
                  <Node
                    isLink
                    size="sm"
                    isRemovable
                    node={selectedRole}
                    onRemoveClick={onRemoveRoleClick}
                  />
                ) : (
                  <Search
                    showConcepts
                    predefinedResults={allSetupAccounts}
                    containerStyles={{
                      height: 24,
                    }}
                    onDropdownElementClick={({ node }) => {
                      onChooseRoleClick(node);
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          <div className={`${classes.mt30} ${classes.ml40} ${classes.mr40}`} style={{marginBottom: '200px'}}>
            <div className={`${classes.alignCenter}`}>
              {selectedRole && selectedRole.id && accountsTbox[selectedRole.id] ? <Node size="md" isLink node={accountsTbox[selectedRole.id]}/> : null}
              <GeneratePublicInvite
                subName={selectedRole && selectedRole.id && accountsTbox[`${selectedRole.id}`] ? accountsTbox[`${selectedRole.id}`].title : null}
                onClick={() => createInvite(selectedRole)}
              >
              </GeneratePublicInvite>
            </div>

            {publicInvites && publicInvites.length ?
              <div>
                <Table className={`${classes.mr10} ${classes.mb5} ${classes.table}`}>
                  <TableBody>
                    {publicInvites.map((invite, index) => {
                      if (selectedRole && (Number(invite.role) !== Number(selectedRole.id))) return null;
                      return (
                        <InviteRow
                          index={index}
                          invite={invite}
                          classes={classes}
                          key={invite.code + invite.is_enabled}
                          onEnableInvite={onEnableInvite}
                          deleteInvitation={deleteInvitation}
                          accountsTbox={accountsTbox}
                        >
                        </InviteRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </div>
            : null}
          </div>
        </div>
      : null}
    </div>
  );
};

export default PublicInviteTab;
